module.exports = __webpack_public_path__ + "img/r-cb6-r1.d1562bfe.gif";